import React, { useState, useEffect } from "react";
import EmailModalImg from "../../assets/EmailModalImg.png";

const SubscribeEmailModal = ({ show, onClose }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate a loading time of 3 seconds
    if (show) {
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
      }, 3000); // 3 seconds delay
    }
  }, [show]);

  return (
    <div
      className={`modal fade ${show ? "show d-block" : ""}`}
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: show ? "rgba(0, 0, 0, 0.5)" : "transparent" }}
      onClick={onClose}
    >
      <div
        className="modal-dialog modal-dialog-centered"
        role="document"
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the modal
      >
        <div className="modal-content p-4 text-center">
          <button
            type="button"
            className="btn-close position-absolute top-0 end-0 m-3"
            onClick={onClose}
            aria-label="Close"
          ></button>

          {/* Show loading spinner or modal content based on loading state */}
          {loading ? (
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          ) : (
            <>
              <div className="d-flex justify-content-center">
                <img
                  src={EmailModalImg}
                  alt="modal"
                  className="my-4"
                  style={{ width: "30%" }}
                />
              </div>
              <h1 className="mb-3 fs-1 fw-bold">Successfully Subscribed</h1>
              <div className="d-flex justify-content-center">
                <p className="my-4 fs-5 w-75 text-center">
                  Thank you for subscribing! Look out for news and updates.
                </p>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default SubscribeEmailModal;
